import {combineReducers} from '@reduxjs/toolkit';
import user from './userSlice';
import dialog from './global/dialogSlice';
import toast from './global/toastSlice';

const createReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        dialog,
        toast,
        user,
        ...asyncReducers,
    });

    /*
      Reset the redux store when user logged out
       */
    if (action.type === 'user/userLoggedOut') {
        // state = undefined;
    }

    return combinedReducer(state, action);
};

export default createReducer;
